module.exports = __webpack_public_path__ + "static/media/info-sub.ec317131.svg";